module.exports = __webpack_public_path__ + "5e922efbe77ab761f446ab0214068792.svg";